import { render, staticRenderFns } from "./editStudentProfile.vue?vue&type=template&id=d8a4ec16&scoped=true&"
import script from "./editStudentProfile.vue?vue&type=script&lang=js&"
export * from "./editStudentProfile.vue?vue&type=script&lang=js&"
import style0 from "./editStudentProfile.vue?vue&type=style&index=0&id=d8a4ec16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a4ec16",
  null
  
)

export default component.exports